import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import styles from "./index.module.css";
import { passwordSchema } from "../../yup";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { Button } from "react-bootstrap";
import { ButtonLoader } from "../ButtonLoader";

const PasswordForm = ({ onSubmit }) => {
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(passwordSchema),
  });

  return (
    <>
      <form className={styles.passwordForm}>
        {/* Current Password */}
        <div className={styles.field}>
          <label>Current Password</label>

          <div className={styles.passwordWrapper}>
            <input
              type={showCurrent ? "text" : "password"}
              {...register("currentPassword")}
            />

            <span
              className={styles.eyeIcon}
              onClick={() => setShowCurrent((v) => !v)}
              role="button"
              aria-label="Toggle current password visibility"
            >
              {showCurrent ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {errors.currentPassword && (
            <p className={styles.error}>{errors.currentPassword.message}</p>
          )}
        </div>

        {/* New Password */}
        <div className={styles.field}>
          <label>New Password</label>

          <div className={styles.passwordWrapper}>
            <input
              type={showNew ? "text" : "password"}
              {...register("newPassword")}
            />

            <span
              className={styles.eyeIcon}
              onClick={() => setShowNew((v) => !v)}
              role="button"
              aria-label="Toggle new password visibility"
            >
              {showNew ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {errors.newPassword && (
            <p className={styles.error}>{errors.newPassword.message}</p>
          )}
        </div>

        {/* Confirm Password */}
        <div className={styles.field}>
          <label>Confirm Password</label>

          <div className={styles.passwordWrapper}>
            <input
              type={showConfirm ? "text" : "password"}
              {...register("confirmPassword")}
            />

            <span
              className={styles.eyeIcon}
              onClick={() => setShowConfirm((v) => !v)}
              role="button"
              aria-label="Toggle confirm password visibility"
            >
              {showConfirm ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          {errors.confirmPassword && (
            <p className={styles.error}>{errors.confirmPassword.message}</p>
          )}
        </div>
      </form>
      <div className={styles.formActions}>
        <Button
          type="submit"
          className={styles.profileSaveBtn}
          disabled={isSubmitting}
          onClick={handleSubmit(onSubmit)}
        >
          {isSubmitting ? <ButtonLoader show={isSubmitting} /> : "Submit"}
        </Button>
        {/* <Button
          variant="outline-primary"
          type="button"
          className={styles.cancelBtn}
          onClick={onCancel}
        >
          Cancel
        </Button> */}
      </div>
    </>
  );
};

export default PasswordForm;
